import { render } from "./StockRecipes.vue?vue&type=template&id=f4db0e7c&scoped=true"
import script from "./StockRecipes.vue?vue&type=script&lang=js"
export * from "./StockRecipes.vue?vue&type=script&lang=js"

import "./StockRecipes.vue?vue&type=style&index=0&id=f4db0e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4db0e7c"]])

export default __exports__